import { FetchLookupsResponse } from '@lib/api';

export function getExpectedHandlingWaitingTimeFromLookupsResponse(
  lookupsResponse: FetchLookupsResponse,
): { expectedWaitingTime: number; expectedHandlingTime: number } {
  if (lookupsResponse.restaurants.length) {
    const restaurant = lookupsResponse.restaurants[0];

    return {
      expectedWaitingTime: restaurant.expectedWaitingTime,
      expectedHandlingTime: restaurant.expectedHandlingTime,
    };
  }

  if (lookupsResponse.group) {
    return {
      expectedWaitingTime: lookupsResponse.group.expectedWaitingTime,
      expectedHandlingTime: lookupsResponse.group.expectedHandlingTime,
    };
  }

  return {
    expectedWaitingTime: 0, // TODO: what should be the default vakue? maybe from a branch?
    expectedHandlingTime: 0, // TODO: what should be the default vakue? maybe from a branch?
  };
}
